export default __webpack_public_path__ + "static/media/1947.9e9965c8.png";